import {Component, ElementRef, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {StromcheckRequestService} from '../services/request.service';
import {ElementService} from '../../services/element.service';
import {DecimalPipe} from '@angular/common';
import {EingabeStepComponent} from '../eingabe/eingabe.step.component';
import {PortalService} from '../../services/portal.service';
import {MatDialog} from '@angular/material/dialog';
import {StromcheckAnfrage} from "../anfrage/stromcheck.anfrage";
import {UntypedFormGroup} from "@angular/forms";

/**
 *
 */
@Component({
    selector: 'app-stromcheck-ergebnis',
    templateUrl: './ergebnis.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class ErgebnisComponent extends EingabeStepComponent implements OnInit {

  /**
   * get Stromcheckanfrage
   */
  anfrage: StromcheckAnfrage;

  /**
   * form for validation
   */
  form: UntypedFormGroup;

  /**
   * textkey prefix
   */
  textkeyPrefix: string = "stromcheck.ergebnis";

  /**
   * data for the dialog registration
   */
  dialogData: any = {};

  /**
   * current portalId
   */
  portalId: string;

  /**
   * toggle if this is an internal project or not.
   */
  internalPortal: boolean;

  /**
   * hide report download
   */
  hideReportDownload: boolean;

  /**
   * Toggle to force the Dialog/NL-Box
   */
  forceDialog: boolean = false;

  /**
   * URL for the report to download
   */
  reportUrl: string;

  /**
   * URL for showing the WPC or HEC
   */
  url: string;

  /**
   * URL for showing the SDC
   */
  sdcUrl: string;

  /**
   * URL for showing the WPC
   */
  wpcUrl: string;

  /**
   * URL for showing the HEC
   */
  hecUrl: string;

  /**
   * Event emitter activated every time when class changes after car electricity input
   */
  classHasChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * Event emitter activated every time when car electricity input changes
   */
  carElectricityHasChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * toggle for showing the WPC advisor teaser
   */
  showWpcAdvisorteaser: boolean = true;

  /**
   * indicator if there is a result available or not.
   */
  hasResult: boolean = true;

  /**
   * The resultWrapper element
   */
  @ViewChild('resultWrapper') resultWrapper: ElementRef;

  /**
   * holds the id of the html element where to jump to after click on dialog hint
   */
  idTargetElement: string = null;

  /**
   * toggle if we want to display the download module
   */
  showDownload: boolean;

  /**
   * @inheritDoc
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: StromcheckRequestService,
              protected elementService: ElementService, public element: ElementRef, protected portalService: PortalService,
              public dialog: MatDialog) {
    super(stepService, router, requestService, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    this.anfrage = this.requestService.getAnfrage();

    if(!this.anfrage.result || Object.keys(this.anfrage.result).length === 0) {
      // There is no result available. Maybe a reload and no third party cookies. Show error message.
      this.hasResult = false;
    }

    // get the current portalId
    this.portalId = this.portalService.currentPortalId;
    this.internalPortal = this.portalService.isInternalPortal();
    this.hideReportDownload = this.portalService.getConfigAsBool('embed.newsletter.report.download');

    // should we force to see the dialog box
    this.forceDialog = this.portalService.getConfigAsBool('embed.newsletter.force');

    this.initDialogData();

    this.initRelinkUrls();

    this.initResult();
  }

  /**
   * event emitter activated if class changes
   */
  onClassChange(classChanged: boolean): void {
    let timeout = 0;
    // scroll up to top if class changes
    if(classChanged) {
      this.elementService.scrollToElement(this.resultWrapper.nativeElement);
      timeout = 800;
    }
    setTimeout(() => {
      this.classHasChanged.emit(classChanged);
      this.elementService.initTooltips(this.element);
    }, timeout);
  }

  /**
   * event emitter activated if car electricity changes
   */
  onCarElectricityChange(carElectricityChanged: boolean): void {
    if(carElectricityChanged) {
      this.carElectricityHasChanged.emit(carElectricityChanged);
    }
  }

  /**
   * Initializes the URLs that lead to sdc odr wpc
   */
  initRelinkUrls(): void{
    this.sdcUrl = this.portalService.getConfig("alladvisors.link.solardachcheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId);
    this.wpcUrl = this.portalService.getConfig("alladvisors.link.waermepumpencheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId);
    this.hecUrl = this.portalService.getConfig("alladvisors.link.heizcheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId);
  }

  /**
   * init the result data from the backend data.
   */
  initResult(): void {
    // report
    this.reportUrl = this.anfrage.result?.report ?? null;

    // download module
    this.showDownload = !this.hideReportDownload && this.reportUrl && !this.internalPortal;

    // add css class to dialog or download module
    if(this.forceDialog) {
      this.idTargetElement = 'lead';
    }
    else if(this.showDownload) {
      this.idTargetElement = 'download';
    }
  }

  /**
   * create data object that will be sent to the backend with the registration for the dialog
   */
  initDialogData(): void {
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.dialogData = {
        requestId: requestId,
        bmOptinSource: window.location.href,
        doisource: 'stc'
      };
    });
  }

  /**
   * Function is called if the users registered for the dialog
   */
  dialogRegistered(result: string): void {
    const anfrage = this.requestService.getAnfrage();
    anfrage.dialogResult = result;

    this.requestService.setAnfrage(anfrage);
    this.requestService.saveDataToServer();
  }

  /**
   * Event emitter activated if value on has_heating_pump from user input changes
   */
  onValueChangeHasHeatingPump(valueChanged: boolean) {
    this.showWpcAdvisorteaser = !valueChanged;
  }
}
